import React, { useState, useContext } from 'react';
import {
      CCard,
      CCardBody,
      CRow,
      CCol,
      CBadge,
      CWidgetStatsC,
      CButton,
      CFormSwitch
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import {
      cilLightbulb,
      cilSettings,
      cilHome,
      cilPowerStandby
} from '@coreui/icons';
import { ActiveLinkContext } from '../../components/ActiveLinkContext';

const HomeAssistantWidget = () => {
      const { setActiveLink } = useContext(ActiveLinkContext);
      
      // Navigation handlers using context
      const goToDevices = () => setActiveLink('hadevices');
      const goToAutomations = () => setActiveLink('haautomations');
      const goToDashboard = () => setActiveLink('homeassistant');
      const goToIntegrations = () => setActiveLink('haintegrations');

      const [stats, setStats] = useState({
            activeLights: 3,
            totalLights: 5,
            activeAutomations: 2,
            totalAutomations: 4,
            temperature: 72,
            humidity: 45
      });

      const [switches, setSwitches] = useState({
            lights: {
                  switch1: false,
                  switch2: false
            },
            automations: {
                  switch1: false,
                  switch2: false
            },
            temperature: {
                  switch1: false,
                  switch2: false
            },
            humidity: {
                  switch1: false,
                  switch2: false
            }
      });

      const handleSwitchToggle = (category, switchName) => {
            setSwitches(prev => ({
                  ...prev,
                  [category]: {
                        ...prev[category],
                        [switchName]: !prev[category][switchName]
                  }
            }));
      };

      return (
            <CCard className="mb-4">
                  <CCardBody>
                        <CRow className="g-4">
                              <CCol sm={6} md={3}>
                                    <CCard className="h-100 border-info">
                                          <CCardBody>
                                                <div className="d-flex justify-content-between mb-3">
                                                      <h4 className="card-title mb-0">Lights</h4>
                                                      <CIcon 
                                                            icon={cilLightbulb} 
                                                            size="xl"
                                                            className="text-info cursor-pointer"
                                                            onClick={goToDevices}
                                                            style={{ cursor: 'pointer' }}
                                                      />
                                                </div>
                                                <CWidgetStatsC
                                                      color="info"
                                                      value={`${stats.activeLights}/${stats.totalLights}`}
                                                      title="Active Lights"
                                                      inverse
                                                      progress={{ 
                                                            value: (stats.activeLights / stats.totalLights) * 100,
                                                            color: 'success'
                                                      }}
                                                />
                                                <div className="mt-3">
                                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <CFormSwitch 
                                                                  id="lights-switch1"
                                                                  label="Living Room"
                                                                  checked={switches.lights.switch1}
                                                                  onChange={() => handleSwitchToggle('lights', 'switch1')}
                                                            />
                                                            <CButton color="info" size="sm">On/Off</CButton>
                                                      </div>
                                                      <div className="d-flex justify-content-between align-items-center">
                                                            <CFormSwitch 
                                                                  id="lights-switch2"
                                                                  label="Kitchen"
                                                                  checked={switches.lights.switch2}
                                                                  onChange={() => handleSwitchToggle('lights', 'switch2')}
                                                            />
                                                            <CButton color="info" size="sm">On/Off</CButton>
                                                      </div>
                                                </div>
                                          </CCardBody>
                                    </CCard>
                              </CCol>
                              <CCol sm={6} md={3}>
                                    <CCard className="h-100 border-warning">
                                          <CCardBody>
                                                <div className="d-flex justify-content-between mb-3">
                                                      <h4 className="card-title mb-0">Automations</h4>
                                                      <CIcon 
                                                            icon={cilSettings} 
                                                            size="xl"
                                                            className="text-warning cursor-pointer"
                                                            onClick={goToAutomations}
                                                            style={{ cursor: 'pointer' }}
                                                      />
                                                </div>
                                                <CWidgetStatsC
                                                      color="warning"
                                                      value={`${stats.activeAutomations}/${stats.totalAutomations}`}
                                                      title="Active Automations"
                                                      inverse
                                                      progress={{ 
                                                            value: (stats.activeAutomations / stats.totalAutomations) * 100,
                                                            color: 'info'
                                                      }}
                                                />
                                                <div className="mt-3">
                                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <CFormSwitch 
                                                                  id="auto-switch1"
                                                                  label="Morning Routine"
                                                                  checked={switches.automations.switch1}
                                                                  onChange={() => handleSwitchToggle('automations', 'switch1')}
                                                            />
                                                            <CButton color="warning" size="sm">Enable</CButton>
                                                      </div>
                                                      <div className="d-flex justify-content-between align-items-center">
                                                            <CFormSwitch 
                                                                  id="auto-switch2"
                                                                  label="Night Mode"
                                                                  checked={switches.automations.switch2}
                                                                  onChange={() => handleSwitchToggle('automations', 'switch2')}
                                                            />
                                                            <CButton color="warning" size="sm">Enable</CButton>
                                                      </div>
                                                </div>
                                          </CCardBody>
                                    </CCard>
                              </CCol>
                              <CCol sm={6} md={3}>
                                    <CCard className="h-100 border-primary">
                                          <CCardBody>
                                                <div className="d-flex justify-content-between mb-3">
                                                      <h4 className="card-title mb-0">Temperature</h4>
                                                      <CIcon 
                                                            icon={cilHome} 
                                                            size="xl"
                                                            className="text-primary cursor-pointer"
                                                            onClick={goToDashboard}
                                                            style={{ cursor: 'pointer' }}
                                                      />
                                                </div>
                                                <CWidgetStatsC
                                                      color="primary"
                                                      value={`${stats.temperature}°F`}
                                                      title="Temperature"
                                                      inverse
                                                      progress={{ 
                                                            value: (stats.temperature / 100) * 100,
                                                            color: 'warning'
                                                      }}
                                                />
                                                <div className="mt-3">
                                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <CFormSwitch 
                                                                  id="temp-switch1"
                                                                  label="AC"
                                                                  checked={switches.temperature.switch1}
                                                                  onChange={() => handleSwitchToggle('temperature', 'switch1')}
                                                            />
                                                            <CButton color="primary" size="sm">Toggle</CButton>
                                                      </div>
                                                      <div className="d-flex justify-content-between align-items-center">
                                                            <CFormSwitch 
                                                                  id="temp-switch2"
                                                                  label="Heat"
                                                                  checked={switches.temperature.switch2}
                                                                  onChange={() => handleSwitchToggle('temperature', 'switch2')}
                                                            />
                                                            <CButton color="primary" size="sm">Toggle</CButton>
                                                      </div>
                                                </div>
                                          </CCardBody>
                                    </CCard>
                              </CCol>
                              <CCol sm={6} md={3}>
                                    <CCard className="h-100 border-success">
                                          <CCardBody>
                                                <div className="d-flex justify-content-between mb-3">
                                                      <h4 className="card-title mb-0">Humidity</h4>
                                                      <CIcon 
                                                            icon={cilPowerStandby} 
                                                            size="xl"
                                                            className="text-success cursor-pointer"
                                                            onClick={goToDashboard}
                                                            style={{ cursor: 'pointer' }}
                                                      />
                                                </div>
                                                <CWidgetStatsC
                                                      color="success"
                                                      value={`${stats.humidity}%`}
                                                      title="Humidity"
                                                      inverse
                                                      progress={{ 
                                                            value: stats.humidity,
                                                            color: 'primary'
                                                      }}
                                                />
                                                <div className="mt-3">
                                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <CFormSwitch 
                                                                  id="humid-switch1"
                                                                  label="Humidifier"
                                                                  checked={switches.humidity.switch1}
                                                                  onChange={() => handleSwitchToggle('humidity', 'switch1')}
                                                            />
                                                            <CButton color="success" size="sm">Toggle</CButton>
                                                      </div>
                                                      <div className="d-flex justify-content-between align-items-center">
                                                            <CFormSwitch 
                                                                  id="humid-switch2"
                                                                  label="Dehumidifier"
                                                                  checked={switches.humidity.switch2}
                                                                  onChange={() => handleSwitchToggle('humidity', 'switch2')}
                                                            />
                                                            <CButton color="success" size="sm">Toggle</CButton>
                                                      </div>
                                                </div>
                                          </CCardBody>
                                    </CCard>
                              </CCol>
                              <CCol sm={6} md={3}>
                                    <CButton 
                                          color="primary" 
                                          size="sm" 
                                          onClick={goToIntegrations}
                                    >
                                          Manage Integrations
                                    </CButton>
                              </CCol>
                        </CRow>
                  </CCardBody>
            </CCard>
      );
};

export default HomeAssistantWidget;
